<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <button class="btn-back" type="button" @click="voltar">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                        </svg>
                                        Voltar
                                    </button>
                                    <h1 class="modern-title modern-title--logo" v-if="tipoPeriodico">
                                        <img :src="tipoPeriodico.urlImagemVue"
                                             :alt="tipoPeriodico.nmTipoPeriodico"
                                             class="header-logo"
                                             @error="onImgError" />
                                    </h1>
                                    <h1 class="modern-title" v-else>Periódicos</h1>
                                    <p class="modern-subtitle">{{ tipoPeriodico ? tipoPeriodico.dsTipoPeriodico : 'Edições disponíveis do periódico selecionado.' }}</p>
                                </div>
                                <div class="header-actions" v-if="user">
                                    <div class="search-box">
                                        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                        </svg>
                                        <input type="text"
                                               class="modern-search-input"
                                               placeholder="Pesquisar artigos, edições ou temas..."
                                               aria-label="Pesquisar periódicos"
                                               v-model="pesquisa"
                                               @keyup.enter="pesquisar" />
                                        <button class="modern-btn modern-btn-primary" type="button" @click="pesquisar">
                                            Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="lista-periodicos-content" :class="tipoPeriodico ? 'classe-' + tipoPeriodico.classe : ''">
                        <div class="filtros-bar" v-if="tipoPeriodico">
                            <div class="filtros-inner">
                                <span class="filtros-label">Filtrar por</span>

                                <div class="filtro-group">
                                    <label class="filtro-lbl">Ano</label>
                                    <select class="filtro-select" v-model="ano">
                                        <option value="0">Todos</option>
                                        <option :value="item" v-for="item in anosPeriodicos" :key="item">{{ item }}</option>
                                    </select>
                                </div>

                                <div class="filtro-group">
                                    <label class="filtro-lbl">Mês</label>
                                    <select class="filtro-select" v-model="mes">
                                        <option value="0">Todos</option>
                                        <option value="1">Janeiro</option>
                                        <option value="2">Fevereiro</option>
                                        <option value="3">Março</option>
                                        <option value="4">Abril</option>
                                        <option value="5">Maio</option>
                                        <option value="6">Junho</option>
                                        <option value="7">Julho</option>
                                        <option value="8">Agosto</option>
                                        <option value="9">Setembro</option>
                                        <option value="10">Outubro</option>
                                        <option value="11">Novembro</option>
                                        <option value="12">Dezembro</option>
                                    </select>
                                </div>

                                <button class="filtro-btn" @click="filtrar">
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M22 3H2l8 9.46V19l4 2V12.46z" /></svg>
                                    Filtrar
                                </button>

                                <span class="filtros-count" v-if="lstPeriodicos.length > 0">
                                    {{ lstPeriodicos.length }} edição{{ lstPeriodicos.length !== 1 ? 'ões' : '' }}
                                </span>
                            </div>
                        </div>

                        <main v-if="tipoPeriodico">
                            <div class="section-label">
                                <span>Edições disponíveis</span>
                            </div>

                            <div class="editions-grid" v-if="lstPeriodicos.length > 0">
                                <BoxPeriodico v-for="item in lstPeriodicos"
                                              :key="item.idPeriodico"
                                              :periodico="item" />
                            </div>

                            <div class="empty-state" v-else>
                                <div class="empty-icon">📭</div>
                                <p class="empty-title">Nenhuma edição encontrada</p>
                                <p class="empty-sub">Tente ajustar os filtros de ano ou mês.</p>
                            </div>

                            <OutrasRevistas v-if="lstOutrasEdicoes.length > 0"
                                            class="outras-wrap"
                                            :lstTipoRevistas="lstOutrasEdicoes" />
                        </main>
                    </div>
                </div>
            </div>
        </div>
        <Modais></Modais>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import OutrasRevistas from '@/components/Ferramentas/Periodicos/OutrasRevistas'
    import BoxPeriodico from '@/components/Ferramentas/Periodicos/BoxPeriodico'

    import logoLicicon from '@/assets/img/Periodicos/licicon_metade_grande-min.png'
    import logoNp from '@/assets/img/Periodicos/logo_revista_np_grande.png'
    import logoPregoeiro from '@/assets/img/Periodicos/logo_revista_pregoeiro_grande.png'
    import logoGovernanca from '@/assets/img/Periodicos/logo_revista_governanca_grande.png'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'ListaPeriodicos',
        components: { Header, Modais, OutrasRevistas, BoxPeriodico },
        props: ['tipo'],
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        data: function () {
            return {
                tipoPeriodico: null,
                pesquisa: '',
                dadosTipoPeriodico: null,
                lstPeriodicos: [],
                lstOutrasEdicoes: [],
                lstTipoPeriodico: [],
                anosPeriodicos: [],
                mes: 0,
                ano: 0,
            }
        },
        methods: {
            voltar() {
                this.$router.push({ name: 'Periodicos' })
            },

            pesquisar() {
                if (this.pesquisa && this.pesquisa.trim() !== '') {
                    this.$router.push({ name: 'PesquisaPeriodicos', params: { termo: this.pesquisa.trim() } })
                }
            },

            onImgError(e) {
                e.target.style.display = 'none'
            },

            filtrar() {
                this.carregaPeriodicos()
            },

            carregaPeriodicos() {
                let $this = this
                axios.get(`${urlApi}/Periodico/ListarPeriodicos`, {
                    params: { idTipoPeriodico: $this.tipoPeriodico.idTipoPeriodico, mes: $this.mes, ano: $this.ano }
                })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data
                            $this.anosPeriodicos = result.anosPeriodicos
                            $this.lstPeriodicos = result.lstPeriodicos
                        } else {
                            avisoErro('Não foi possível carregar os periódicos')
                        }
                    })
                    .catch(() => avisoErro('Não foi possível carregar os periódicos'))
            },

            carregaTiposPeriodico() {
                let $this = this
                axios.get(`${urlApi}/TipoPeriodico/OutrasRevistas`)
                    .then(res => {
                        if (res.data.success) {
                            $this.lstTipoPeriodico = []
                            if (res.data.data != null) {
                                for (let i = 0; i < res.data.data.length; i++) {
                                    let tp = res.data.data[i]
                                    tp.urlImagemVue = $this.getImagem(tp.nmTipoPeriodico)
                                    tp.classe = $this.getClassTipoPeriodico(tp.nmTipoPeriodico)
                                    $this.lstTipoPeriodico.push(tp)
                                }
                                $this.carregaTipoPeriodico()
                            }
                        } else {
                            avisoErro('Não foi possível carregar os tipos periódicos')
                            $this.lstTipoPeriodico = []
                        }
                    })
                    .catch(() => {
                        avisoErro('Não foi possível carregar os tipos periódicos')
                        $this.lstTipoPeriodico = []
                    })
            },

            carregaTipoPeriodico() {
                let $this = this
                axios.get(`${urlApi}/TipoPeriodico/Get/${$this.tipo}`)
                    .then(res => {
                        if (res.data.success) {
                            $this.dadosTipoPeriodico = res.data.data
                            $this.tipoPeriodico = $this.lstTipoPeriodico.find(x => x.idTipoPeriodico == $this.dadosTipoPeriodico.idTipoPeriodico)
                            $this.lstOutrasEdicoes = $this.lstTipoPeriodico.filter(v => v.idTipoPeriodico != $this.dadosTipoPeriodico.idTipoPeriodico)
                            $this.carregaPeriodicos()
                        } else {
                            avisoErro('Não foi possível carregar os periódicos')
                            $this.tipoPeriodico = null
                        }
                    })
                    .catch(() => {
                        avisoErro('Não foi possível carregar os periódicos')
                        $this.tipoPeriodico = null
                    })
            },

            getImagem(nmTipoPeriodico) {
                if (nmTipoPeriodico.includes('Licicon')) return logoLicicon
                if (nmTipoPeriodico.includes('Pregoeiro')) return logoPregoeiro
                if (nmTipoPeriodico.includes('Negócios')) return logoNp
                if (nmTipoPeriodico.includes('Governança')) return logoGovernanca
                return null
            },

            getClassTipoPeriodico(nmTipoPeriodico) {
                if (nmTipoPeriodico.includes('Licicon')) return 'licicon'
                if (nmTipoPeriodico.includes('Pregoeiro')) return 'pregoeiro'
                if (nmTipoPeriodico.includes('Negócios')) return 'np'
                if (nmTipoPeriodico.includes('Governança')) return 'governanca'
                return 'none'
            },

            load() {
                this.ano = moment().format('YYYY')
                this.mes = 0
                this.carregaTiposPeriodico()
            },
        },
        created() {
            this.load()
        },
        watch: {
            tipo() {
                this.load()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400&family=DM+Sans:wght@300;400;500;600&family=Merriweather:ital,wght@0,900;1,400&display=swap');

    .modern-header {
        background: #1a1a2e;
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        flex: 1 1 280px;
        min-width: 200px;
        max-width: 720px;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .btn-back {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: none;
        color: #6b7280;
        font-size: 13px;
        font-weight: 600;
        padding: 0;
        margin-bottom: 4px;
        cursor: pointer;
        width: fit-content;
    }

    .btn-back:hover {
        color: #2563eb;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    .modern-title--logo {
        line-height: 1;
        margin-bottom: 8px;
    }

    .header-logo {
        display: block;
        max-height: 72px;
        max-width: 380px;
        -o-object-fit: contain;
        object-fit: contain;
        -o-object-position: left center;
        object-position: left center;
        -webkit-filter: brightness(0) invert(1);
        filter: brightness(0) invert(1);
        opacity: .92;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    .header-actions {
        display: flex;
        align-items: center;
        flex: 1 1 320px;
        max-width: 480px;
    }

    .search-box {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        flex: 1;
        min-width: 0;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
        color: #1f2937;
    }

    .modern-search-input:focus {
        outline: none;
        border-color: #2563eb;
        background: white;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        min-height: 42px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        white-space: nowrap;
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

    .modern-btn-primary:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 20px 0;
        }

        .header-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .title-section,
        .header-actions {
            max-width: 100%;
            width: 100%;
        }

        .modern-title {
            font-size: 24px;
        }

        .header-logo {
            max-height: 52px;
            max-width: 100%;
        }
    }

    /* Cores usadas pelos filtros e pela grade (var) */
    .lista-periodicos-content {
        --warm-white: #fdfcf9;
        --warm-off: #f5f2eb;
        --gold: #C8922A;
        --gold-light: #E8A83A;
        --gold-pale: #fdf0d5;
        --dark: #1A1A2E;
        --dark-mid: #2a2a42;
        --muted: #7a7060;
        --border: #DEDBD4;
        --border-gold: rgba(200, 146, 42, 0.3);
        --shadow-sm: 0 2px 8px rgba(26, 26, 46, 0.07);
        --shadow-md: 0 8px 32px rgba(26, 26, 46, 0.1);
        --shadow-lg: 0 20px 60px rgba(26, 26, 46, 0.14);
        font-family: 'DM Sans', sans-serif;
        background: var(--warm-white);
        color: var(--dark);
        min-height: 100%;
        overflow-x: hidden;
    }

    /* ── FILTROS BAR ── */
    .filtros-bar {
        background: #fff;
        border-bottom: 1px solid var(--border);
        box-shadow: var(--shadow-sm);
        position: sticky;
        top: 0;
        z-index: 50;
    }

    .filtros-inner {
        max-width: 1680px;
        margin: 0 auto;
        padding: 0 3rem;
        height: 60px;
        display: flex;
        align-items: center;
        gap: 1.5rem;
    }

    .filtros-label {
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: var(--muted);
        white-space: nowrap;
    }

    .filtro-group {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .filtro-lbl {
        font-size: 0.72rem;
        font-weight: 600;
        color: var(--muted);
        white-space: nowrap;
    }

    .filtro-select {
        background: var(--warm-off);
        border: 1px solid var(--border);
        border-radius: 6px;
        padding: 0.45rem 0.85rem;
        font-family: 'DM Sans', sans-serif;
        font-size: 0.8rem;
        color: var(--dark);
        cursor: pointer;
        outline: none;
        transition: border-color 0.2s;

        &:focus {
            border-color: var(--gold);
        }
    }

    .filtro-btn {
        display: flex;
        align-items: center;
        gap: 0.45rem;
        background: var(--gold);
        color: #fff;
        border: none;
        border-radius: 6px;
        padding: 0.5rem 1.1rem;
        font-family: 'DM Sans', sans-serif;
        font-size: 0.76rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
        transition: background 0.2s;
        white-space: nowrap;

        &:hover {
            background: var(--gold-light);
        }
    }

    .filtros-count {
        margin-left: auto;
        font-size: 0.72rem;
        color: var(--muted);
        font-weight: 500;
    }

    /* ── MAIN ── */
    main {
        max-width: 1680px;
        margin: 0 auto;
        padding: 2.5rem 3rem 4rem;
    }

    .section-label {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1.75rem;

        span {
            font-size: 0.7rem;
            font-weight: 700;
            letter-spacing: 0.14em;
            text-transform: uppercase;
            color: var(--muted);
        }

        &::after {
            content: '';
            flex: 1;
            height: 1px;
            background: var(--border);
        }
    }

    /* ── GRID DE EDIÇÕES ── */
    .editions-grid {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 1.25rem;
    }

    /* ── EMPTY STATE ── */
    .empty-state {
        text-align: center;
        padding: 5rem 2rem;
    }

    .empty-icon {
        font-size: 3rem;
        margin-bottom: 1rem;
    }

    .empty-title {
        font-family: 'Playfair Display', serif;
        font-size: 1.25rem;
        font-weight: 700;
        color: var(--dark);
        margin-bottom: 0.5rem;
    }

    .empty-sub {
        font-size: 0.9rem;
        color: var(--muted);
    }

    /* ── OUTRAS REVISTAS ── */
    .outras-wrap {
        margin-top: 4rem;
        padding-top: 3rem;
        border-top: 1px solid var(--border);
    }

    /* ── RESPONSIVE ── */
    @media (max-width: 1400px) {
        .editions-grid {
            grid-template-columns: repeat(4, 1fr);
        }
    }

    @media (max-width: 1100px) {
        .editions-grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @media (max-width: 1000px) {
        main {
            padding: 2rem 1.25rem 3rem;
        }

        .filtros-inner {
            padding: 0 1.25rem;
            gap: 1rem;
            overflow-x: auto;
        }

        .editions-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 575px) {
        .editions-grid {
            grid-template-columns: 1fr;
        }

        .filtros-count {
            display: none;
        }
    }
</style>
